import { render, staticRenderFns } from "./interview-company-record.vue?vue&type=template&id=3de595cb&scoped=true"
import script from "./interview-company-record.vue?vue&type=script&lang=js"
export * from "./interview-company-record.vue?vue&type=script&lang=js"
import style0 from "./interview-company-record.vue?vue&type=style&index=0&id=3de595cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de595cb",
  null
  
)

export default component.exports